/**
 * Created by evdokimov on 26.05.2017.
 */
import BaseFormMediator from './BaseFormMediator'

export default function OldBaseFormMediator()
{}

OldBaseFormMediator.prototype = _.create(BaseFormMediator.prototype, {

    fillDateSelection: function(reportParametersObject)
    {
        reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRangeJSON();
    }
    
});


// WEBPACK FOOTER //
// ./web/js/reports/OldBaseFormMediator.js